import { HandleSubmitProps } from "interfaces";
import { CognitoSignInProps } from "interfaces/Cognito";

export default function (
  values: CognitoSignInProps,
  { props: { action } }: HandleSubmitProps
) {
  return action({ ...values });
}
